import { Drawer } from "antd";
import React from "react";
import { useMenu } from "@/context/MenuContext";
import MenuContent from "@/components/MenuContent";

export function MenuDrawer() {

    const { isOpen, onMenuClose } = useMenu();

    return (
        <div className={'custom-menu-container'}>
            <Drawer
                placement="top"
                onClose={onMenuClose}
                open={isOpen}
                getContainer={false}
                destroyOnClose={true}
                closable={false}
                maskClosable={true}
                className={'custom-menu-drawer'}
                styles={{ content: { top: 40 } }}
            >
                <MenuContent isDrawer={true} />
            </Drawer>
        </div>

    )
}